const errorDispatcher = (err, dispatch, errorType) => {
	if (err.response) {
		console.log("====================================");
		console.log(err.response);
		console.log("====================================");
		// eslint-disable-next-line
		if (err.response.status == 401) {
			dispatch({
				type: errorType,
				payload: "Please login to continue",
				title: "Unauthorized",
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 417) {
			dispatch({
				type: errorType,
				payload: err.response.data.message,
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 402 || err.response.status == 405) {
			dispatch({
				type: errorType,
				payload: err.response.data.detail,
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 400) {
			dispatch({
				type: errorType,
				payload: err.response.data.message,
				code: err.response.data.code,
			});
		} else {
			dispatch({
				type: errorType,
				payload: "internal server error",
			});
		}
	} else if (err.code) {
		dispatch({
			type: errorType,
			payload: err.message,
			title: err.title,
			code: err.code,
		});
	} else {
		console.log(err);
		dispatch({
			type: errorType,
			payload: "Network Error!",
		});
	}
};

export default errorDispatcher;
